import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { Form, Row, Spinner } from "react-bootstrap";
import { Skeleton } from "@mui/material";

import { educationApi } from "../../../utility/api/apiList";

import cartType from "../../../redux/actions/cart/cartType";
import {
  showSuccessAlert,
  showDangerAlert,
  closeAlert,
} from "../../../redux/actions/alert/alertActions";

import useAxios from "../../../hooks/useAxios";
import scrollToTop from "../../../libs/scrollToTop";
import { educationGender, educationTypes } from "../../../libs/getConstants";

import { PurchaseSelect } from "../groupPurchase";
import ButtonComponent from "../../../components/public/button";
import InputComponent from "../../../components/public/form/input";

import { Wrapper } from "./styledCompanyDetailPage";

const EditCompanyDetail = ({ data, updateEditedDatas }) => {
  const [constantsList, setConstantsList] = useState([]);
  const [constantsTypeList, setConstantsTypeList] = useState([]);
  const [constantsGenderList, setConstantsGenderList] = useState([]);
  const [stateId, setStateId] = useState(data.state);

  const userDetail = useSelector((state) => state.userDetail);
  const constantsDetail = useSelector((state) => state.constantsDetail);

  const educationType = educationTypes();
  const educationGenders = educationGender();

  const dispatch = useDispatch();

  const schema = yup.object().shape({
    name: yup.string().required("وارد کردن نام سازمان ضروری است."),
    english_name: yup
      .string()
      .matches(
        /^([a-zA-Z]+\s?)+$/,
        "متن انتخابی باید به زبان انگلیسی باشد و فقط یک فاصله بین حروف باشد."
      )
      .required("وارد کردن نام انگلیسی سازمان ضروری است."),
    type: yup.object().default({
      label: data.typeLabel?.name,
      value: data.type,
    }),
    gender: yup.object().default({
      label: data.genderLabel?.name,
      value: data.gender,
    }),
    state: yup.object().default({
      label: data.state_str,
      value: data.state,
    }),
    city: yup.object().default({
      label: data.city_str,
      value: data.city,
    }),
    address: yup
      .string()
      .test(
        "len",
        "مطمئن شوید طول آدرس حداقل 10 باشد.",
        (val) => val?.length > 10
      )
      .required("آدرس سازمان وارد شود."),
    postal_code: yup
      .number()
      .typeError("لطفا عدد وارد کنید.")
      .test(
        "len",
        "مطمئن شوید طول کد پستی 10 باشد.",
        (val) => val?.toString().length === 10
      )
      .required("کد پستی سازمان وارد شود."),
    national_id: yup
      .number()
      .typeError("لطفا عدد وارد کنید.")
      .test(
        "len",
        "مطمئن شوید طول شناسه ملی 11 باشد.",
        (val) => val?.toString().length === 11
      )
      .required("شناسه ملی سازمان وارد شود."),
  });

  const {
    register,
    handleSubmit,
    setError,
    control,
    formState: { isValid, errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const { isLoading, run: createNewCompanyRun } = useAxios({
    url: `${educationApi}${data.id}/`,
    method: "put",
  });

  useEffect(() => {
    scrollToTop();
    document.title = "ایجاد سازمان جدید";
    if (!userDetail.isLogin) {
      dispatch(showDangerAlert("لطفا ابتدا وارد شوید"));
    }
  }, []);

  useEffect(() => {
    if (constantsDetail.constants.length !== 0) {
      setConstantsList(constantsDetail.constants.other);
      const count = Object.keys(educationType).length;
      let array = [];
      for (let i = 0, emp; i < count; i++) {
        emp = educationType[i];
        array.push({ id: i, name: emp });
      }
      let genderArray = [];
      const countGender = Object.keys(educationGenders).length;
      for (let i = 0, empGender; i < countGender; i++) {
        empGender = educationGenders[i];
        genderArray.push({ id: i, name: empGender });
      }
      setConstantsGenderList(genderArray);
      setConstantsTypeList(array);
    }
  }, [constantsDetail.constants]);

  const handleKeyUpEnglishName = (e) => {
    if (!/^([a-zA-Z]+\s?)+$/.test(e.target.value)) {
      e.target.value = "";
      errors.english_name = "pattern";
    } else {
      delete errors.english_name;
    }
  };

  const subjectOptions = (listOption, inputId, checkOptionsList) => {
    if (checkOptionsList) {
      if (inputId === 3 || inputId === 4) {
        return listOption.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
      } else if (inputId === 5) {
        return listOption.map((item) => {
          return {
            label: item.ostan,
            value: item.id,
          };
        });
      } else if (inputId === 6) {
        return listOption
          ?.filter((option) => option.ostan === stateId)
          .map((item) => {
            return {
              label: item.shahr,
              value: item.id,
            };
          });
      }
    }
  };

  const onSubmit = (e) => {
    const data = {
      ...e,
      gender: e.gender.value,
      city: e.city.value,
      state: e.state.value,
      type: e.type.value,
    };
    createNewCompanyRun({
      ...data,
    })
      .then((response) => {
        let selectArray = {
          id: response.data.id,
          name: response.data.name,
        };
        dispatch(closeAlert());
        dispatch({
          type: cartType.SET_COMPANY_DETAILS,
          payload: selectArray,
        });
        dispatch(showSuccessAlert("سازمان  با موفقیت ویرایش شد."));
        updateEditedDatas();
      })
      .catch((error) => {
        Object.entries(error.response.data).map((item) =>
          setError(item[0], { type: "test", message: item[1] })
        );
      });
  };

  const companyDetailFormData = [
    {
      id: 1,
      typeInput: "text",
      nameInput: "name",
      valueInput: data.name,
      placeholder: "نام سازمان",
      formGroupClassName: "col-12 col-md-6",
    },
    {
      id: 2,
      typeInput: "text",
      placeholder: "نام انگلیسی",
      nameInput: "english_name",
      valueInput: data.english_name,
      onKeyUpInput: handleKeyUpEnglishName,
      formGroupClassName: "col-12 col-md-6",
    },
    {
      id: 3,
      typeInput: "select",
      nameInput: "type",
      defaultSelectValues: {
        label: data.typeLabel?.name,
        value: data.type,
      },
      placeholder: "نوع سازمان",
      formGroupClassName: "col-12 col-md-6",
      checkOptionsList: true,
      optionsList: constantsTypeList,
    },
    {
      id: 4,
      typeInput: "select",
      nameInput: "gender",
      defaultSelectValues: {
        label: data.genderLabel?.name,
        value: data.gender,
      },
      placeholder: "جنسیت",
      formGroupClassName: "col-12 col-md-6",
      checkOptionsList: true,
      optionsList: constantsGenderList,
    },
    {
      id: 5,
      typeInput: "select",
      nameInput: "state",
      defaultSelectValues: {
        label: data.state_str,
        value: data.state,
      },
      placeholder: "استان",
      formGroupClassName: "col-12 col-md-6",
      checkOptionsList: constantsList.state,
      optionsList: constantsList.state,
    },
    {
      id: 6,
      typeInput: "select",
      nameInput: "city",
      defaultSelectValues: {
        label: data.city_str,
        value: data.city,
      },
      placeholder: "شهر",
      formGroupClassName: "col-12 col-md-6",
      checkOptionsList: stateId !== 0,
      optionsList: constantsList.city,
    },
    {
      id: 7,
      typeInput: "text",
      nameInput: "address",
      valueInput: data.address,
      placeholder: "آدرس سازمان",
      formGroupClassName: "col-12",
    },
    {
      id: 8,
      nameInput: "postal_code",
      typeInput: "number",
      valueInput: data.postal_code,
      placeholder: "کد پستی سازمان",
      formGroupClassName: "col-12 col-md-6",
    },
    {
      id: 9,
      typeInput: "number",
      nameInput: "national_id",
      valueInput: data.national_id,
      placeholder: "شناسه ملی سازمان",
      formGroupClassName: "col-12 col-md-6",
    },
  ];

  return (
    <Wrapper className="mx-auto d-flex justify-content-center align-items-center">
      {!constantsDetail.error && (
        <Form
          onSubmit={handleSubmit(onSubmit)}
          autoComplete="off"
          className="w-100"
        >
          <Row className="p-0">
            {companyDetailFormData.map((item) => (
              <span className={`${item.formGroupClassName} mt-5`} key={item.id}>
                {item.typeInput !== "select" ? (
                  <InputComponent
                    type={item.typeInput}
                    placeholder={item.placeholder}
                    defaultValue={item.valueInput}
                    containerClass={`input ${
                      errors[item.nameInput]?.message ? "invalid-input" : ""
                    }`}
                    register={register(item.nameInput)}
                    onKeyUp={item.onKeyUpInput}
                    className={
                      item.typeInput === "number" ? "no-arrows" : undefined
                    }
                  />
                ) : (
                  <>
                    {constantsDetail.loading ? (
                      <Skeleton width={220} height={80} />
                    ) : (
                      <Controller
                        control={control}
                        name={`${item.nameInput}`}
                        render={({ field }) => {
                          const { onChange } = field;
                          return (
                            <PurchaseSelect
                              closeMenuOnSelect={true}
                              defaultValue={item.defaultSelectValues}
                              className={`select ${
                                errors[item.nameInput]?.message
                                  ? "invalid-input"
                                  : ""
                              }`}
                              onChange={(val) => {
                                onChange(val);
                                if (item.nameInput === "state") {
                                  setStateId(val.value);
                                }
                              }}
                              options={subjectOptions(
                                item.optionsList,
                                item.id,
                                item.checkOptionsList
                              )}
                            />
                          );
                        }}
                      />
                    )}
                  </>
                )}
                <Form.Text className="error-message">
                  {errors[item.nameInput]?.message}
                </Form.Text>
              </span>
            ))}
          </Row>
          <Row className="p-0">
            <ButtonComponent
              type="submit"
              className="mx-auto my-5 col-12 col-md-6"
              disabled={!isValid}
            >
              {isLoading ? (
                <Spinner
                  as="span"
                  animation="border"
                  role="status"
                  aria-hidden="true"
                ></Spinner>
              ) : (
                "ثبت تغییرات"
              )}
            </ButtonComponent>
          </Row>
        </Form>
      )}
    </Wrapper>
  );
};

export default EditCompanyDetail;
